<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('callFee') }}
        </h1>
      </div>
    </div>
    <call-fee-overview-list></call-fee-overview-list>
  </main>
</template>

<script>

import CallFeeOverviewList from "./CallFeeOverviewList";

export default {
  components: {CallFeeOverviewList},
  i18n: {
    messages: {
      en: {
        callFee: 'Call fee',
      },
      vi: {
        callFee: 'Cước gọi',
      }
    }
  }
}
</script>
